var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _submenuMutationObserver, _hoverDispatchTimer, _resizeListener, _overflowSubmenuListener, _state, _pointerIdleTimer, _lastPointer, _onPointerMove, _HeaderMenu_instances, reconcilePointerTarget_fn, startPointerTracking_fn, stopPointerTracking_fn, _deactivate, getOverflowListLinksHeight_fn, getHeaderVisibleHeight_fn, setFullOpenHeaderHeight_fn, _preloadImages, cleanupMutationObserver_fn;
import { Component } from "@theme/component";
import { debounce, onDocumentLoaded, setHeaderMenuStyle } from "@theme/utilities";
import { MegaMenuHoverEvent } from "@theme/events";
const HOVER_COMMIT_DELAY_MS = 150;
class HeaderMenu extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _HeaderMenu_instances);
    __publicField(this, "requiredRefs", ["overflowMenu"]);
    /**
     * @type {MutationObserver | null}
     */
    __privateAdd(this, _submenuMutationObserver, null);
    /** @type {ReturnType<typeof setTimeout> | undefined} */
    __privateAdd(this, _hoverDispatchTimer);
    /**
     * Debounced resize event listener to recalculate menu style
     */
    __privateAdd(this, _resizeListener, debounce(() => {
      setHeaderMenuStyle();
    }, 100));
    __privateAdd(this, _overflowSubmenuListener, () => {
      __privateGet(this, _deactivate).call(this);
    });
    /**
     * @type {State}
     */
    __privateAdd(this, _state, {
      activeItem: null
    });
    /**
     * @type {ReturnType<typeof setTimeout> | undefined}
     */
    __privateAdd(this, _pointerIdleTimer);
    /**
     * Last known pointer position for Safari hit-test reconciliation.
     * @type {{ x: number, y: number }}
     */
    __privateAdd(this, _lastPointer, { x: 0, y: 0 });
    /**
     * Update the safety box idle state on the active menu item.
     * @param {PointerEvent} event
     */
    __privateAdd(this, _onPointerMove, (event) => {
      const activeLink = __privateGet(this, _state).activeItem;
      if (!activeLink) return;
      __privateGet(this, _lastPointer).x = event.clientX;
      __privateGet(this, _lastPointer).y = event.clientY;
      const moving = Math.abs(event.movementX) >= 1 || event.movementY >= 1;
      activeLink.dataset.safetyBox = "".concat(moving);
      clearTimeout(__privateGet(this, _pointerIdleTimer));
      if (moving) {
        __privateSet(this, _pointerIdleTimer, setTimeout(() => {
          if (__privateGet(this, _state).activeItem) {
            __privateGet(this, _state).activeItem.dataset.safetyBox = "false";
            __privateMethod(this, _HeaderMenu_instances, reconcilePointerTarget_fn).call(this);
          }
        }, 50));
      } else {
        __privateMethod(this, _HeaderMenu_instances, reconcilePointerTarget_fn).call(this);
      }
    });
    /**
     * Activate the selected menu item immediately
     * @param {PointerEvent | FocusEvent} event
     */
    __publicField(this, "activate", (event) => {
      var _a;
      if (!(event.target instanceof Element) || !this.headerComponent) return;
      let item = findMenuItem(event.target);
      if (!item || item == __privateGet(this, _state).activeItem) return;
      const isDefaultSlot = event.target.slot === "";
      this.dataset.overflowExpanded = (!isDefaultSlot).toString();
      const previouslyActiveItem = __privateGet(this, _state).activeItem;
      if (previouslyActiveItem) {
        previouslyActiveItem.ariaExpanded = "false";
      }
      __privateGet(this, _state).activeItem = item;
      this.ariaExpanded = "true";
      item.ariaExpanded = "true";
      let submenu = findSubmenu(item);
      const hasSubmenu = Boolean(submenu);
      if (!hasSubmenu && !isDefaultSlot) {
        submenu = this.overflowMenu;
      }
      if (submenu) {
        clearTimeout(__privateGet(this, _hoverDispatchTimer));
        __privateSet(this, _hoverDispatchTimer, void 0);
        const committedItem = item;
        if (event instanceof FocusEvent) {
          this.dispatchEvent(new MegaMenuHoverEvent());
        } else {
          __privateSet(this, _hoverDispatchTimer, setTimeout(() => {
            __privateSet(this, _hoverDispatchTimer, void 0);
            if (__privateGet(this, _state).activeItem === committedItem) {
              this.dispatchEvent(new MegaMenuHoverEvent());
            }
          }, HOVER_COMMIT_DELAY_MS));
        }
        submenu.dataset.active = "";
        __privateMethod(this, _HeaderMenu_instances, cleanupMutationObserver_fn).call(this);
        __privateSet(this, _submenuMutationObserver, new MutationObserver(() => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              var _a2;
              if (submenu.offsetHeight > 0) {
                (_a2 = this.headerComponent) == null ? void 0 : _a2.style.setProperty("--submenu-height", "".concat(submenu.offsetHeight, "px"));
                __privateMethod(this, _HeaderMenu_instances, cleanupMutationObserver_fn).call(this);
              }
            });
          });
        }));
        __privateGet(this, _submenuMutationObserver).observe(submenu, { childList: true, subtree: true });
        setTimeout(() => {
          __privateMethod(this, _HeaderMenu_instances, cleanupMutationObserver_fn).call(this);
        }, 500);
      }
      let finalHeight = (submenu == null ? void 0 : submenu.offsetHeight) || 0;
      if (!isDefaultSlot) {
        const overflowListHeight = __privateMethod(this, _HeaderMenu_instances, getOverflowListLinksHeight_fn).call(this);
        if (hasSubmenu) {
          const overflowHeight = ((_a = this.overflowMenu) == null ? void 0 : _a.offsetHeight) || 0;
          finalHeight = Math.max(overflowHeight, overflowListHeight);
        } else {
          finalHeight = overflowListHeight;
        }
      }
      if (!submenu) {
        finalHeight = 0;
      }
      const headerVisibleHeight = __privateMethod(this, _HeaderMenu_instances, getHeaderVisibleHeight_fn).call(this);
      this.headerComponent.style.setProperty("--submenu-height", "".concat(finalHeight, "px"));
      __privateMethod(this, _HeaderMenu_instances, setFullOpenHeaderHeight_fn).call(this, finalHeight, headerVisibleHeight);
      this.style.setProperty("--submenu-opacity", "1");
      __privateMethod(this, _HeaderMenu_instances, startPointerTracking_fn).call(this, item, previouslyActiveItem);
    });
    /**
     * Deactivate the active item immediately
     * @param {HTMLElement | null} [item]
     */
    __privateAdd(this, _deactivate, (item = __privateGet(this, _state).activeItem) => {
      var _a, _b;
      if (!item || item != __privateGet(this, _state).activeItem) return;
      if (this.overflowListHovered || ((_a = this.overflowMenu) == null ? void 0 : _a.matches(":hover"))) return;
      clearTimeout(__privateGet(this, _hoverDispatchTimer));
      __privateSet(this, _hoverDispatchTimer, void 0);
      (_b = this.headerComponent) == null ? void 0 : _b.style.setProperty("--submenu-height", "0px");
      __privateMethod(this, _HeaderMenu_instances, setFullOpenHeaderHeight_fn).call(this, 0, 0);
      this.style.setProperty("--submenu-opacity", "0");
      this.dataset.overflowExpanded = "false";
      const submenu = findSubmenu(item);
      document.body.removeEventListener("pointermove", __privateGet(this, _onPointerMove));
      __privateMethod(this, _HeaderMenu_instances, stopPointerTracking_fn).call(this, item);
      __privateGet(this, _state).activeItem = null;
      this.ariaExpanded = "false";
      item.ariaExpanded = "false";
      if (submenu) {
        delete submenu.dataset.active;
      }
    });
    /**
     * Preload images that are set to load lazily.
     */
    __privateAdd(this, _preloadImages, () => {
      const images = this.querySelectorAll('img[loading="lazy"]');
      images == null ? void 0 : images.forEach((image) => image.removeAttribute("loading"));
    });
  }
  connectedCallback() {
    var _a;
    super.connectedCallback();
    onDocumentLoaded(__privateGet(this, _preloadImages));
    window.addEventListener("resize", __privateGet(this, _resizeListener));
    (_a = this.overflowMenu) == null ? void 0 : _a.addEventListener("pointerleave", __privateGet(this, _overflowSubmenuListener));
  }
  disconnectedCallback() {
    var _a;
    super.disconnectedCallback();
    window.removeEventListener("resize", __privateGet(this, _resizeListener));
    document.body.removeEventListener("pointermove", __privateGet(this, _onPointerMove));
    if (__privateGet(this, _state).activeItem) {
      __privateMethod(this, _HeaderMenu_instances, stopPointerTracking_fn).call(this, __privateGet(this, _state).activeItem);
    }
    (_a = this.overflowMenu) == null ? void 0 : _a.removeEventListener("pointerleave", __privateGet(this, _overflowSubmenuListener));
    __privateMethod(this, _HeaderMenu_instances, cleanupMutationObserver_fn).call(this);
    clearTimeout(__privateGet(this, _hoverDispatchTimer));
    __privateSet(this, _hoverDispatchTimer, void 0);
  }
  /**
   * Get the overflow menu
   */
  get overflowMenu() {
    var _a, _b;
    return (
      /** @type {HTMLElement | null} */
      (_b = (_a = this.refs.overflowMenu) == null ? void 0 : _a.shadowRoot) == null ? void 0 : _b.querySelector('[part="overflow"]')
    );
  }
  /**
   * Whether the overflow list is hovered
   * @returns {boolean}
   */
  get overflowListHovered() {
    var _a, _b, _c, _d;
    return (_d = (_c = (_b = (_a = this.refs.overflowMenu) == null ? void 0 : _a.shadowRoot) == null ? void 0 : _b.querySelector('[part="overflow-list"]')) == null ? void 0 : _c.matches(":hover")) != null ? _d : false;
  }
  get headerComponent() {
    return (
      /** @type {HTMLElement | null} */
      this.closest("header-component")
    );
  }
  /**
   * Deactivate the active item after a delay
   * @param {PointerEvent | FocusEvent} event
   */
  deactivate(event) {
    var _a;
    if (!(event.target instanceof Element)) return;
    const menu = findSubmenu(__privateGet(this, _state).activeItem);
    const isMovingWithinMenu = event.relatedTarget instanceof Node && (menu == null ? void 0 : menu.contains(document.activeElement));
    const isMovingToSubmenu = event.relatedTarget instanceof Node && event.type === "blur" && (menu == null ? void 0 : menu.contains(event.relatedTarget));
    const isMovingToOverflowMenu = event.relatedTarget instanceof Node && ((_a = event.relatedTarget.parentElement) == null ? void 0 : _a.matches('[slot="overflow"]'));
    if (isMovingWithinMenu || isMovingToOverflowMenu || isMovingToSubmenu) {
      if (__privateGet(this, _state).activeItem) {
        __privateMethod(this, _HeaderMenu_instances, stopPointerTracking_fn).call(this, __privateGet(this, _state).activeItem);
      }
      return;
    }
    __privateGet(this, _deactivate).call(this);
  }
}
_submenuMutationObserver = new WeakMap();
_hoverDispatchTimer = new WeakMap();
_resizeListener = new WeakMap();
_overflowSubmenuListener = new WeakMap();
_state = new WeakMap();
_pointerIdleTimer = new WeakMap();
_lastPointer = new WeakMap();
_onPointerMove = new WeakMap();
_HeaderMenu_instances = new WeakSet();
/**
 * Check if the pointer is over a different menu item and trigger activation if so.
 * Works around Safari not re-evaluating hit targets after pseudo-element changes.
 */
reconcilePointerTarget_fn = function() {
  const { x, y } = __privateGet(this, _lastPointer);
  requestAnimationFrame(() => {
    const target = document.elementFromPoint(x, y);
    if (!target) return;
    const listItem = target.closest(".menu-list__list-item");
    if (listItem && !listItem.contains(__privateGet(this, _state).activeItem)) {
      listItem.dispatchEvent(new PointerEvent("pointerenter", { bubbles: false }));
    }
  });
};
/**
 * Begin pointer tracking for the safety box on the newly active item.
 * @param {HTMLElement} item
 * @param {HTMLElement | null} previousItem
 */
startPointerTracking_fn = function(item, previousItem) {
  var _a, _b, _c;
  if (previousItem) {
    __privateMethod(this, _HeaderMenu_instances, stopPointerTracking_fn).call(this, previousItem);
  } else {
    document.body.addEventListener("pointermove", __privateGet(this, _onPointerMove));
  }
  const rect = item.getBoundingClientRect();
  const isOverlap = (_a = this.headerComponent) == null ? void 0 : _a.hasAttribute("data-submenu-overlap-bottom-row");
  const boundary = isOverlap ? (_b = this.headerComponent) == null ? void 0 : _b.querySelector(".header__row--top") : this.headerComponent;
  item.style.setProperty("--box-height", "".concat(((_c = boundary == null ? void 0 : boundary.getBoundingClientRect().bottom) != null ? _c : 0) - rect.top, "px"));
};
/**
 * Stop pointer tracking and remove all safety box properties from an item.
 * @param {HTMLElement} item
 */
stopPointerTracking_fn = function(item) {
  window.clearTimeout(__privateGet(this, _pointerIdleTimer));
  __privateSet(this, _pointerIdleTimer, void 0);
  item.style.removeProperty("--box-height");
  delete item.dataset.safetyBox;
};
_deactivate = new WeakMap();
getOverflowListLinksHeight_fn = function() {
  var _a, _b, _c, _d;
  const slottedMenuLinks = (_b = (_a = this.overflowMenu) == null ? void 0 : _a.querySelector("slot")) == null ? void 0 : _b.assignedElements();
  if (!slottedMenuLinks) return ((_c = this.overflowMenu) == null ? void 0 : _c.offsetHeight) || 0;
  const mapSubmenus = (cb) => {
    slottedMenuLinks.forEach((link) => {
      const submenu = (
        /** @type {HTMLElement | null} */
        link.querySelector('[ref="submenu[]"]')
      );
      if (submenu) {
        cb(submenu);
      }
    });
  };
  mapSubmenus((submenu) => {
    submenu.style.setProperty("display", "none");
  });
  const height = ((_d = this.overflowMenu) == null ? void 0 : _d.offsetHeight) || 0;
  mapSubmenus((submenu) => {
    submenu.style.removeProperty("display");
  });
  return height;
};
/**
 * Read the visible header height before submenu height writes invalidate layout.
 * @returns {number}
 */
getHeaderVisibleHeight_fn = function() {
  var _a, _b;
  if (!this.headerComponent) return 0;
  const isOverlapSituation = this.headerComponent.hasAttribute("data-submenu-overlap-bottom-row");
  return isOverlapSituation && this.headerComponent.offsetHeight > 0 ? (
    /** @type {HTMLElement | null} */
    (_b = (_a = this.headerComponent.querySelector(".header__row--top")) == null ? void 0 : _a.offsetHeight) != null ? _b : 0
  ) : this.headerComponent.offsetHeight;
};
/**
 * Calculate and set the full open header height. If the submenu is not open, the full open header height is 0.
 * @param {number} submenuHeight
 * @param {number} headerVisibleHeight
 */
setFullOpenHeaderHeight_fn = function(submenuHeight, headerVisibleHeight) {
  var _a;
  if (!this.headerComponent) return;
  const nothingToOpen = submenuHeight === 0;
  const fullOpenHeaderHeight = nothingToOpen ? 0 : submenuHeight + headerVisibleHeight;
  (_a = this.headerComponent) == null ? void 0 : _a.style.setProperty("--full-open-header-height", "".concat(fullOpenHeaderHeight, "px"));
};
_preloadImages = new WeakMap();
cleanupMutationObserver_fn = function() {
  var _a;
  (_a = __privateGet(this, _submenuMutationObserver)) == null ? void 0 : _a.disconnect();
  __privateSet(this, _submenuMutationObserver, null);
};
if (!customElements.get("header-menu")) {
  customElements.define("header-menu", HeaderMenu);
}
function findMenuItem(element) {
  var _a;
  if (!(element instanceof Element)) return null;
  if (element == null ? void 0 : element.matches('[slot="more"')) {
    return findMenuItem((_a = element.parentElement) == null ? void 0 : _a.querySelector('[slot="overflow"]'));
  }
  return element == null ? void 0 : element.querySelector('[ref="menuitem"]');
}
function findSubmenu(element) {
  var _a;
  const submenu = (_a = element == null ? void 0 : element.parentElement) == null ? void 0 : _a.querySelector('[ref="submenu[]"]');
  return submenu instanceof HTMLElement ? submenu : null;
}
